import { SliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { TUser, TUserState } from 'shared/types/user';

const initialState: TUserState = {
  isAuthenticated: false,
};

/* istanbul ignore next */
const userSlice = createSlice<TUserState | null, SliceCaseReducers<TUser>, string>({
  initialState,
  name: 'user',
  reducers: {},
});

export const { reducer: userReducer } = userSlice;
